import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useTextsApi } from "../../../../../http/patrol/useTexts";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { PATROL } from "../../AdminSystemSettings";
import TextDetails from "./TextDetails";

const Text: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { textId } = useParams<{ textId: string }>();
  const textsApi = useTextsApi();

  const aborter = useRef(new AbortController());
  const { error, data, isMutating, trigger } = textsApi.getAdminText(aborter.current.signal);

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: PATROL },
    {
      url: `/admin/systems/${systemId}/settings?tab=7`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.texts.plural}`,
    },
    { display: data?.id ?? "" },
  ];

  useEffect(() => {
    textId && trigger(textId);
  }, [textId]);

  return (
    <>
      <Header title={`${i18n.translation.texts.singular}: ${data?.id}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <TextDetails text={!error ? data : undefined} disabled={isMutating || !!error} />
      </FlexContent>
    </>
  );
};

export default Text;
